export const matchCharOptions = [
  { label: "标签1", value: "1" },
  { label: "标签2", value: "2" },
  { label: "标签3", value: "3" },
  { label: "标签4", value: "4" },
  { label: "标签5", value: "5" },
  { label: "标签6", value: "6" },
  { label: "标签7", value: "7" },
  { label: "标签8", value: "8" },
  { label: "标签9", value: "9" },
  { label: "标签10", value: "10" },
  { label: "标签11", value: "11" },
  { label: "标签12", value: "12" },
];
export const separatorOptions = [
  { label: "英文下划线(_)", value: 1, key: "_" },
  { label: "英文分号(;)", value: 2, key: ";" },
  { label: "英文逗号(,)", value: 3, key: "," },
  { label: "井字符号(#)", value: 4, key: "#" },
  { label: "英文横杠(-)", value: 5, key: "-" },
];
